import parseFraction from './parseFraction';

/**
 * Convert fractional price to decimal price
 * @param {String} fractionalPrice - fractional price, e.g. 'Evs', '1/4', '4/1', '9/2',
 * @return {Number} - decimal price, e.g. 2, 1.25, 5.0, 5.5
 */
export default function convertFractionalPrice(fracPrice) {
    if (fracPrice === 'Evs') {
        return 2;
    }
    return parseFraction(fracPrice) + 1;
}



// WEBPACK FOOTER //
// /src/js/common/utils/convertFractionalPrice.js